<template>
  <div id="app">
    
    <wh7 msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import wh7 from './components/wh7.vue'
import _fetchCommonData from '../src/plugin/FetchCommonData/fetchCommonData.js'
export default {
  name: 'App',
  components: {
    wh7
  },
  watch: {
    '$route': function(){
document.body.scrollTop = 0
document.documentElement.scrollTop = 0

    }
  },
  created(){
	_fetchCommonData({
		url: 'https://rich.wenhua.com.cn/',
        title: 'wh7睿期大户室期货软件'
	}).then(
		(res)=>{
			let obj = {};
			res.forEach(item => {
				obj[item.keyname] = item.value;
			});
			this.$store.commit('SetCommonDataObj', obj);
			document.title = obj['appShortName_12'] + obj['appFullName_12'] + ' - 估值视角研判期货价格';
		}
	);
  }
  
}
</script>

<style >
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
body,html{height:100%;
font-family: 'Microsoft Yahei', Tahoma, Arial, Helvetica, Simsun, STHeiti;}
#app{
height:100%;	
}

</style>
